import * as React from "react";
import { useSelector } from "react-redux";

export default function OrderSummary({ promoDiscount }) {
  console.log("🚀 ~ OrderSummary ~ promoDiscount:", promoDiscount?.discount)
  // Get the cart data from Redux state
  const { cart } = useSelector((state) => state.cart);
  const { discount } = useSelector((state) => state.promo);
  // Calculate the subtotal by summing the price of each item multiplied by its quantity
  const subtotal = cart.reduce((total, item) => total + item.basePrice * item.quantity, 0);
  
  // Apply discount only on applicable products
  const discountAmount = cart.reduce((discountTotal, item) => {
    const isDiscountApplicable = discount && discount.productId.includes(item._id); // Check if the discount applies to this item
    if (isDiscountApplicable) {
      discountTotal += (item.basePrice * item.quantity * discount.discount) / 100; // Apply discount only on the applicable item
    }
    return discountTotal;
  }, 0);
  
  const total = subtotal - discountAmount;
  if (cart.length === 0) {
    return (
      <section className="flex flex-col self-center px-11 py-9 mt-12 rounded-lg bg-stone-50 w-[90%] max-md:px-5 max-md:mt-10">
        <h2 className="text-2xl font-bold text-black text-center">
          Your cart is empty.
        </h2>
        <p className="text-center text-gray-600 mt-2">
          Please add some items to your cart to view the order summary.
        </p>
      </section>
    );
  }

  return (
    <section className="flex flex-col self-center px-11 py-9 mt-12 rounded-lg bg-stone-50 w-[90%] max-md:px-5 max-md:mt-10 ">
      <div className="flex items-center flex-wrap gap-5 justify-between max-md:max-w-full">
        <div className="flex flex-col items-start self-start text-2xl font-medium leading-none text-black">
          <h2 className="self-stretch lg:text-[40px] md:text-[27.97px] font-baloo sm:text-[14px] text-[14px] font-bold leading-tight">
            Order Summary
          </h2>
        </div>
      </div>

      <div className="flex flex-col leading-[64px]">
  {cart.map((item) => (
    <div key={item._id} className="rotate-[3.469446951953614e-18rad] font-baloo font-medium text-[#000000] text-[8.75px] sm:text-[8.75px] md:text-[17.48px] lg:text-[25px]">
      {item.name} x {item.quantity}
    </div>
  ))}
</div>

<div className="flex flex-col self-end font-semibold whitespace-nowrap leading-[64px] text-slate-800 ">
  {cart.map((item) => (
    <div key={item._id} className="rotate-[9.19348695318866e-19rad] text-[10.56px] sm:text-[10.56px] md:text-[20.98px] font-baloo font-semibold lg:text-[30px]">
      £{(item.basePrice * item.quantity).toFixed(2)}
    </div>
  ))}
</div>


      <hr className="shrink-0 mt-1.5  w-full border-rose-700 border-solid border-[3px]" />

      <div className="mt-4 flex flex-col">
        <div className="flex justify-between items-center text-center">
          <div className="font-baloo font-bold lg:text-[22px] text-[8.4px] sm:text-[8.4px] md:text-[16.78px]">Subtotal</div>
          <div className="lg:text-[34px] font-bold text-[12px] sm:text-[12px] md:text-[20.98px]">£{subtotal.toFixed(2)}</div>
        </div>

        {promoDiscount && (
          <div className="flex justify-between mt-4">
            <div className="text-[#C97C2A] font-baloo font-bold lg:text-[30px] text-[10.5px] sm:text-[10.5px] md:text-[20.98px] ">Discount</div>
            <div className="text-[#C97C2A] font-baloo font-bold lg:text-[40px] md:text-[27.97px]">-£{discountAmount.toFixed(2)}</div>
          </div>
        )}

        <div className="flex justify-between mt-4">
          <div className="text-[#C97C2A] font-baloo font-bold lg:text-[30px] text-[10.5px] sm:text-[10.5px] md:text-[20.98px] ">Total</div>
          <div className="text-[#C97C2A] font-baloo font-bold lg:text-[40px] md:text-[27.97px]">£{total.toFixed(2)}</div>
        </div>
      </div>
    </section>
  );
}
